import { orchestrator } from "satcheljs";
import { drawerPaneClosed } from "owa-drawer";
import { HEADER_PANE_NAME_PREFIX } from "owa-app-pane-group-utils/lib/constants/constants";
import closeHeaderPane from "./closeHeaderPane";

orchestrator(drawerPaneClosed, ({ paneId, targetWindow }) => {
    if (paneId.startsWith(HEADER_PANE_NAME_PREFIX)) {
        closeHeaderPane(paneId, targetWindow, true /* wasDrawerPaneClosed */);
    }
});
